module.exports = __webpack_public_path__ + "img/7ea15c8.png";